// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "_" + "7c8f4582b139f8d0430d" + ".min.js";
};